import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_APPROVE_PHARMACY_ORDER } from "../../action-types/actions";

import i18n from "../../i18n";
export const approvePharmacyOrder = createAsyncThunk(
  ACTIONS_APPROVE_PHARMACY_ORDER.approve_order,
  async ({ orderId, notes }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.approvePharmacyOrder}/${orderId}/approve`,
        { notes: notes || undefined },
      );

      if (response?.status === 200 || response?.data?.status === true) {
        toast.success(i18n.t("pharmacy.toast.orderApprovedSuccessfully"));
        return response.data;
      } else {
        toast.error(response?.data?.message || i18n.t("pharmacy.toast.orderApprovalFailed"));
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorApprovingOrder");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
